import React, { useCallback } from "react";

import Checkbox from "antd/es/checkbox";
import { FormattedMessage } from "react-intl";

import useBoolean from "@mapmycustomers/shared/util/hook/useBoolean";
import { Button } from "@mapmycustomers/ui";

import { reportsWeeklyCardAnalytics } from "@app/scene/reports/reportsAnalytics";

import styles from "./OptingCommon.module.scss";

interface Props {
  onToggle?: (enabled: boolean) => void;
}

const OptedOut: React.FC<Props> = ({ onToggle }) => {
  const [optInCheck, , , changeOptInCheck] = useBoolean(true, true);
  const handleClick = useCallback(() => {
    reportsWeeklyCardAnalytics.clicked(["Opt In"]);
    onToggle?.(true);
  }, [onToggle]);

  const handleChange = useCallback(() => {
    changeOptInCheck();
  }, [changeOptInCheck]);

  return (
    <div className={styles.container}>
      <div>
        <p>
          <FormattedMessage
            id="reports.weeklyReportCard.optIn"
            defaultMessage="Get a rundown of your previous week’s performance sent to your inbox <strong>each Monday</strong>"
            description="Title for Opt in to weekly reports"
            values={{
              strong: (boldText: string) => <strong>{boldText}</strong>,
            }}
          />
        </p>
      </div>
      <div>
        <p className={styles.optingInDescription}>
          <Checkbox checked={optInCheck} onChange={handleChange} />
          <span className={styles.descriptionText}>
            <FormattedMessage
              id="reports.weeklyReportCard.optingToWeeklyReport.description"
              defaultMessage="By checking this, I’m confirming that I want to receive {br}weekly emails from Map My Customers"
              description="Checkbox for Opt in to weekly reports"
              values={{
                br: <br />,
              }}
            />
          </span>
        </p>
      </div>
      <Button disabled={!optInCheck} onClick={handleClick} type="primary">
        <FormattedMessage
          id="reports.weeklyReportCard.optingToReport.optIn"
          defaultMessage="Opt in to weekly emails"
          description="Button for Opt in to weekly reports"
        />
      </Button>
    </div>
  );
};

export default OptedOut;
